import { ButtonProps } from '@chakra-ui/react';
import * as React from 'react';

import { BaseLinkProps } from '@/components/links/BaseLink';
import ButtonLink from '@/components/links/ButtonLink';

export interface PrimaryButtonProps extends BaseLinkProps {
	buttonProps?: ButtonProps;
}

/**
 * @date 9/13/2022 - 1:56:34 PM
 * @param param0
 * @returns {PrimaryButton}
 */
const PrimaryButton: React.FC<React.PropsWithChildren<PrimaryButtonProps>> = ({
	children,
	...rest
}) => {
	return (
		<ButtonLink
			{...rest}
			buttonProps={{
				bg: 'kemenag.500',
				display: { base: 'none', md: 'inline-flex' },
				fontSize: 'md',
				fontWeight: 600,
				color: 'white',
				_hover: {
					bg: 'teal.500',
				},
			}}
		>
			{children}
		</ButtonLink>
	);
};

export default PrimaryButton;
